export default __webpack_public_path__ + "static/media/sunbg.6a609911.webp";